import React from 'react';

const CampaignsPage: React.FC = () => {

  return (
    <div className='page'>

    </div>
  );
};

export default CampaignsPage;
